{
 "base_frame": 0,
 "bbox": [
  289,
  138,
  413,
  304
 ],
 "patch_top": 0.63,
 "visemes": [
  "AA",
  "AH_open",
  "CH",
  "DD",
  "EE",
  "EH",
  "FF",
  "IH",
  "KK",
  "LL",
  "MM",
  "NN",
  "OH",
  "OO",
  "RR",
  "SS",
  "TH",
  "sil"
 ],
 "picked_musetalk_frame": {
  "AA": "AA/010",
  "AH_open": "AH_open/006",
  "OH": "OH/053",
  "OO": "OO/051",
  "EE": "EE/028",
  "IH": "IH/028",
  "EH": "EH/033",
  "MM": "MM/048",
  "FF": "FF/044",
  "TH": "TH/012",
  "SS": "SS/008",
  "CH": "CH/009",
  "DD": "DD/049",
  "KK": "KK/055",
  "NN": "NN/000",
  "LL": "LL/011",
  "RR": "RR/030",
  "sil": "MM/048"
 },
 "patch": {
  "x": [
   0.24,
   0.76
  ],
  "y": [
   0.62,
   0.93
  ],
  "mask": "oval"
 }
}